import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { DriverDashboardRoutingModule } from './driver-dashboard-routing.module';
import { DriverDashboardComponent } from './driver-dashboard/driver-dashboard.component';
import { MaterialModule } from '../shared/material/material.module';

@NgModule({
  declarations: [DriverDashboardComponent],
  imports: [
    CommonModule,
    MaterialModule,
    DriverDashboardRoutingModule
  ]
})
export class DriverDashboardModule { }

export { DriverDashboardComponent } from './driver-dashboard/driver-dashboard.component';
